import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import './App.css';

class ScrollToTopRoute extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { component: Component, ...rest } = this.props;

    return <Route {...rest} render={props => (
      <React.Fragment>
        {Component ? <Component {...props} /> : rest.children}
      </React.Fragment>
    )} />;
  }
}

export default withRouter(ScrollToTopRoute);
